/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.inbox.AnswerOutcome
*/
export var AnswerOutcome;
(function (AnswerOutcome) {
    AnswerOutcome["DECIDED"] = "DECIDED";
    AnswerOutcome["INSUFFICIENT_INFO"] = "INSUFFICIENT_INFO";
    AnswerOutcome["UNDECIDABLE"] = "UNDECIDABLE";
})(AnswerOutcome || (AnswerOutcome = {}));
//# sourceMappingURL=AnswerOutcome.js.map